import { render, staticRenderFns } from "./_edit_form.vue?vue&type=template&id=057aa2da&"
import script from "./_edit_form.vue?vue&type=script&lang=coffee&"
export * from "./_edit_form.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports